module.exports = __webpack_public_path__ + "img/jbt3411_95_1999_32x25.prt.a5d6317b.jpg";